// Иконка колокольчика — нотификации.
import React from "react";

export function BellIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 17h12l-1.5-2V11a4.5 4.5 0 0 0-9 0v4L6 17Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </svg>
  );
}

export default BellIcon;
